class MobileMenu {
  constructor() {
    this.menu = document.querySelector('#menu');
    this.menuButton = document.querySelector('#menu-button');
    this.events();
  }

  events() {
    if (this.menuButton || this.menu) {
      this.menuButton.addEventListener('click', () => this.openMenu());
    }
  }

  openMenu() {
    this.menu.classList.toggle('top-[65px]');
    this.menu.classList.toggle('opacity-100');
    if (this.menu.style.transform == 'translateZ(-10px)') {
      this.menu.style.transform = null;
    } else {
      this.menu.style.transform = 'translateZ(-10px)';
    }
  }
}

export { MobileMenu };
